export interface ICheckOutHospitalPrescriptionRefillRequest {
  hospitalPrescriptionRefillId: number;
  hospitalPrescriptionRefillRowVersion: string;
  hospitalPrescriptionRowVersion: string;
}

export class CheckOutHospitalPrescriptionRefillRequest
  implements ICheckOutHospitalPrescriptionRefillRequest
{
  hospitalPrescriptionRefillId: number;
  hospitalPrescriptionRefillRowVersion: string;
  hospitalPrescriptionRowVersion: string;

  constructor(params: ICheckOutHospitalPrescriptionRefillRequest) {
    this.hospitalPrescriptionRefillId = params.hospitalPrescriptionRefillId;
    this.hospitalPrescriptionRefillRowVersion =
      params.hospitalPrescriptionRefillRowVersion;
    this.hospitalPrescriptionRowVersion = params.hospitalPrescriptionRowVersion;
  }

  static ParseCheckOutHospitalPrescriptionRefillRequest(
    hospitalPrescriptionRefillId: number,
    hospitalPrescriptionRefillRowVersion: string,
    hospitalPrescriptionRowVersion: string,
  ): ICheckOutHospitalPrescriptionRefillRequest {
    return {
      hospitalPrescriptionRefillId,
      hospitalPrescriptionRefillRowVersion,
      hospitalPrescriptionRowVersion,
    };
  }
}
